var _circle;
import * as React from "react";
function SvgDot(props) {
  return /*#__PURE__*/React.createElement("svg", props, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 8
  })));
}
export default SvgDot;